import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import i18n from '@/libs/i18n'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useManufacturerList() {
  // Use toast
  const toast = useToast()

  const refManufacturerListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', sortable: false },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalManufacturers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  

  const dataMeta = computed(() => {
    const localItemsCount = refManufacturerListTable.value ? refManufacturerListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalManufacturers.value,
    }
  })

  const refetchData = () => {
    refManufacturerListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchManufacturers = (ctx, callback) => {
    store
      .dispatch('app-manufacturer/fetchManufacturers', {
        query: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value
      })
      .then(response => {
        const manufacturers = response.data.data;
        callback(manufacturers)
        totalManufacturers.value = response.data.totalItems
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('Error fetching manufacturers list'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  

  return {
    fetchManufacturers,
    tableColumns,
    perPage,
    currentPage,
    totalManufacturers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refManufacturerListTable,
    refetchData
  }
}
